// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vFPk","type":"styles_type__3eUML","choices":"styles_choices__1q-Te"};